import { modalAnatomy as parts } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system';
import getThemes, { ThemesKeys } from './themeShared';

const style = createMultiStyleConfigHelpers(parts.keys);

const baseStyle = () =>
  style.definePartsStyle({
    // define the part you're going to style
    header: {
      fontSize: 'xl',
      minHeight: 16,
      display: 'flex !important',
      px: 5,
      pt: 4,
      alignItems: 'center',
    },
    closeButton: {
      fontSize: 'xl',
      right: 6,
      top: 4,
      borderRadius: 'full',
      p: 4,
      _focusVisible: {
        boxShadow: 'none',
      },
    },
    overlay: {
      bg: 'blackAlpha.200', //change the background
      boxShadow: 'xl',
    },
    dialog: {
      borderRadius: 'xl',
      py: 5,
      px: 6,
    },
    body: {
      p: 6,
    },
    footer: {
      p: 8,
    },
    dialogContainer: {
      alignItems: 'center',
    },
  });

const sublayer = () =>
  style.definePartsStyle({
    // define the part you're going to style
    header: {
      fontSize: 'xl',
      minHeight: 16,
      display: 'flex !important',
      px: 5,
      pt: 4,
      alignItems: 'center',
    },
    closeButton: {
      fontSize: 'xl',
      right: 6,
      top: 4,
      borderRadius: 'full',
      p: 4,
      _focusVisible: {
        boxShadow: 'none',
      },
    },
    overlay: {
      bg: 'blackAlpha.200', //change the background
      boxShadow: 'xl',
      zIndex: '800',
    },
    dialog: {
      borderRadius: 'xl',
      py: 5,
      px: 6,
      zIndex: '800',
    },
    body: {
      p: 6,
    },
    footer: {
      p: 8,
    },
    dialogContainer: {
      alignItems: 'center',
      zIndex: '800',
    },
  });

const sizes = (theme: ThemesKeys) => ({
  sm: style.definePartsStyle({
    dialog: {
      maxWidth: getThemes(theme).sizes.modals.sm,
    },
  }),
  md: style.definePartsStyle({
    dialog: {
      maxWidth: getThemes(theme).sizes.modals.md,
    },
  }),
  lg: style.definePartsStyle({
    dialog: {
      maxWidth: getThemes(theme).sizes.modals.lg,
    },
  }),
  xl: style.definePartsStyle({
    dialog: {
      maxWidth: getThemes(theme).sizes.modals.xl,
    },
  }),
  mobile: style.definePartsStyle({
    dialog: {
      maxWidth: '100%',
      width: '100%',
      bottom: 0,
      left: 0,
      right: 0,
      position: 'fixed',
      margin: 0,
    },
  }),
  tutorial: style.definePartsStyle({
    dialog: {
      maxWidth: '90%',
      maxHeight: '90%',
      width: '90%',
      height: '90%',
      position: 'fixed',
      margin: 'auto',
      borderRadius: '0',
      bg: 'palette.primary.0',
    },
    closeButton: {
      fontSize: 'md',
      top: 4,
      right: 4,
      borderRadius: 'full',
      p: 4,
      _focusVisible: {
        boxShadow: 'none',
      },
      color: 'palette.primary.100',
      zIndex: 999,
    },
    header: {
      fontSize: 'lg',
      minHeight: 16,
      ml: 10,
      pt: 4,
    },
    footer: {
      p: 6,
      justifyContent: 'center',
    },
  }),
  fullscreen: style.definePartsStyle({
    dialog: {
      maxWidth: '100%',
      maxHeight: '100%',
      width: '100%',
      height: '100%',
      bottom: 0,
      left: 0,
      right: 0,
      position: 'fixed',
      margin: 0,
    },
    closeButton: {
      fontSize: 'md',
      top: 4,
      left: 4,
      borderRadius: 'full',
      p: 4,
      _focusVisible: {
        boxShadow: 'none',
      },
    },
    header: {
      fontSize: 'lg',
      minHeight: 16,
      ml: 10,
      pt: 4,
    },
    footer: {
      p: 6,
      justifyContent: 'center',
    },
  }),
  player: style.definePartsStyle({
    dialog: {
      borderRadius: 0,
      maxWidth: '100%',
      maxHeight: '100%',
      width: '100%',
      height: '100%',
      bottom: 0,
      left: 0,
      right: 0,
      position: 'fixed',
      margin: 0,
      bg: 'palette.primary.0',
    },
    body: {
      p: 0,
    },
    closeButton: {
      fontSize: 'md',
      top: 4,
      left: 4,
      borderRadius: 'full',
      p: 4,
      _focusVisible: {
        boxShadow: 'none',
      },
      color: 'palette.primary.100',
    },
    header: {
      fontSize: 'lg',
      minHeight: 16,
      pl: 15,
      mt: '2px',
      color: 'palette.primary.100',
      bg: 'palette.primary.0',
    },
    footer: {
      p: 6,
      justifyContent: 'center',
    },
  }),
});

export const modalTheme = (theme: ThemesKeys) =>
  style.defineMultiStyleConfig({
    baseStyle: baseStyle(),
    variants: {
      sublayer: sublayer(),
    },
    sizes: sizes(theme),
  });

export default (theme: ThemesKeys) => modalTheme(theme);
